import React from 'react';

import { trackEvent } from '@/lib/GA';

import Facebook from '@/images/icons/facebook.svg';
import Twitter from '@/images/icons/twitter.svg';

import styles from './styles.module.scss';

interface Props {
  shareOptions?: Maybe<Maybe<string>[]>;
}

const ShareBlock = ({ shareOptions = [] }: Props) => {
  const handleClick = (site: string, url: string) => {
    trackEvent('Share Offer', 'Clicked Share Offer', site);
    // This is because it would cause hydration error trying to set window.location.href on <a> tags
    window.open(`${url}${window.location.href}`);
  };

  if (!shareOptions?.length) {
    return null;
  }

  return (
    <div className={styles.share}>
      <h2>Share this offer</h2>
      <div className={styles.icons}>
        {shareOptions?.includes('twitter') && (
          <button onClick={() => handleClick('twitter', 'https://www.twitter.com/share?url=')}>
            <Twitter />
          </button>
        )}
        {shareOptions?.includes('facebook') && (
          <button onClick={() => handleClick('facebook', 'https://www.facebook.com/sharer.php?u=')}>
            <Facebook />
          </button>
        )}
      </div>
    </div>
  );
};

export default ShareBlock;
